import { render, staticRenderFns } from "./AddDebitorDlg.vue?vue&type=template&id=5255ad6c&"
import script from "./AddDebitorDlg.vue?vue&type=script&lang=js&"
export * from "./AddDebitorDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddDebitorDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports